// Regnestykket bak Finans-siden. Ren logikk, ingen Firestore, så det kan testes og gjenbrukes.
//
// Beløp på fakturaer lagres i hele kroner. Fakturastatus:
//   pending   – oppdraget er fakturert, men betalingen er ikke trukket (ikke inntekt ennå)
//   captured  – betalingen er trukket fra bestiller
//   refunded  – bestiller er refundert og sjåførens overføring reversert/stoppet
// ordererRefunded: bestiller er refundert (uavhengig av om sjåføren ble belastet)

// Test eller ekte? Nyere fakturaer har merket selv. Eldre arver det fra ordren, og ordrer fra før
// merket fantes avgjøres av kontoene som var med: er bestiller eller sjåfør en testkonto, er det test.
// Uten noe av dette regnes den som ekte, så ekte penger aldri skjules.
export function invoiceIsTest(invoice, ordersById, testUids) {
  if (typeof invoice.isTestAccount === 'boolean') return invoice.isTestAccount;
  const order = ordersById?.get(invoice.orderId);
  if (typeof order?.isTestAccount === 'boolean') return order.isTestAccount;
  return !!testUids && [invoice.ordererUid, invoice.driverUid, order?.ordererUid, order?.driverUid]
    .some(uid => uid && testUids.has(uid));
}

// Utbetaling til sjåfør som ennå ikke er overført
export function isUnpaid(invoice) {
  return !invoice.stripeTransferId && ['pending', 'captured'].includes(invoice.status);
}

// Fakturaen venter på trekk, men det finnes ingen betaling i Stripe (PaymentIntent): kortet ble aldri
// belastet og kan ikke trekkes. Ingen penger har flyttet seg, så den regnes ikke som utestående.
export function isUncharged(invoice) {
  return invoice.status === 'pending' && !invoice.stripePaymentIntentId;
}

// Gebyret er opptjent når betalingen er trukket og bestiller ikke er refundert
export function isEarned(invoice) {
  return invoice.status === 'captured' && !invoice.ordererRefunded;
}

// Refundert til bestiller mens sjåføren beholdt utbetalingen: Tippi bar tapet selv
export function absorbedRefundLoss(invoice) {
  return invoice.ordererRefunded && invoice.status === 'captured' && invoice.stripeTransferId
    ? invoice.driverPayout ?? 0
    : 0;
}

function invoiceDate(invoice) {
  const ts = invoice.paidAt ?? invoice.createdAt;
  return ts?.toDate?.() ?? (ts instanceof Date ? ts : null);
}

const sum = (list, pick) => list.reduce((s, i) => s + (pick(i) ?? 0), 0);

export function summarizeInvoices(invoices, now = new Date()) {
  const uncharged = invoices.filter(isUncharged);
  const charged = invoices.filter(i => !isUncharged(i));
  const earned = invoices.filter(isEarned);
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const last30 = new Date(now.getTime() - 30 * 86400000);

  const earnedSince = (since) => earned.filter(i => {
    const d = invoiceDate(i);
    return d && d >= since;
  });

  return {
    feesEarned:        sum(earned, i => i.tippiFee),
    feesThisMonth:     sum(earnedSince(monthStart), i => i.tippiFee),
    feesLast30Days:    sum(earnedSince(last30), i => i.tippiFee),
    feesPending:       sum(charged.filter(i => i.status === 'pending'), i => i.tippiFee),
    turnover:          sum(earned, i => i.totalAmount),
    unpaidToDrivers:   sum(charged.filter(isUnpaid), i => i.driverPayout),
    unchargedCount:    uncharged.length,
    unchargedAmount:   sum(uncharged, i => i.totalAmount),
    refundLossAbsorbed: sum(invoices, absorbedRefundLoss),
    earnedCount:       earned.length,
  };
}
